import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { ActionTypes } from '@appStore/help/actions';
import * as actions from '@appStore/help/actions';
import { UserGuidesService } from '@appStore/help/services';

@Injectable()
export class UserGuidesEffects {
  constructor(private userGuidesService: UserGuidesService, private actions$: Actions) {}

  loadUserGuides$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.UserGuidesLoad),
      exhaustMap(action => {
        return this.userGuidesService.getMyUserGuides().pipe(
          map(userGuides => new actions.UserGuidesLoadSuccess(userGuides)),
          catchError(error => of(new actions.UserGuidesLoadFail(error)))
        );
      })
    );
  });

  setGuideAsRead$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.GuideSetAsRead),
      map((action: actions.GuideSetAsRead) => action.payload),
      exhaustMap(guideId => {
        return this.userGuidesService.setGuideAsRead(guideId).pipe(
          map(result => new actions.GuideSetAsReadSuccess(result)),
          catchError(error => of(new actions.GuideSetAsReadFail(error)))
        );
      })
    );
  });
}
